
<ion-content id="tutorialpg1" scrollY='false' style="--background:var(--ion-background-color,none);">
  <app-tutorial-slide id="tutorialpg2"></app-tutorial-slide>
</ion-content>
